import { z } from "zod";

export const ZoneType = z.enum(["interaction-buttons", "overworld-notifications"]);
export type ZoneType = z.infer<typeof ZoneType>;
